import { __extends, __assign } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { classNames, liveAnnounce, Level } from 'uitk-react-utils';
import { UitkLoader } from './uitk-loader.esm.js';
import styles from './uitk-loader.css';

var getClassNameList = classNames.bind(styles);
var PageLoader = /** @class */ (function (_super) {
    __extends(PageLoader, _super);
    function PageLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PageLoader.prototype.render = function () {
        var props = this.props;
        var baseCssClass = 'uitk-loader-page';
        var cssClassNames = getClassNameList(baseCssClass, props.className, {
            'is-visible': props.visible
        });
        var title = props.title || props.l10n.formatText('loading');
        if (props.visible) {
            liveAnnounce(title, Level.POLITE);
        }
        return React.createElement(UitkLoader, { className: cssClassNames, title: title, "aria-hidden": !props.visible });
    };
    PageLoader.displayName = 'UitkPageLoader';
    return PageLoader;
}(React.Component));
var UitkPageLoader = function (props) {
    var l10n = useLocalization();
    return React.createElement(PageLoader, __assign({ l10n: l10n }, props));
};

export { PageLoader, UitkPageLoader };
